import { useEffect, useRef } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { PromotionForm } from './Form';
import { Tariff } from '../../../../../types/tariffInfo';
import { usePromotion } from '../../hooks';

interface Props {
  promotionId?: number;
  tariffs: Tariff[];
  onClose: () => void;
  onUpdate: () => void;
}

export function PromotionDialog({ promotionId, tariffs, onClose, onUpdate }: Props) {
  const descriptionElementRef = useRef<HTMLDivElement>(null);
  const { data: promotion, isLoading } = usePromotion(promotionId);

  const isEditMode = !!promotionId;

  useEffect(() => {
    const { current: descriptionElement } = descriptionElementRef;

    if (descriptionElement !== null) {
      descriptionElement.focus();
    }
  }, []);

  return (
    <Dialog
      open
      onClose={onClose}
      scroll="paper"
      maxWidth="md"
      fullWidth
      aria-labelledby="promotion-dialog-title"
      aria-describedby="promotion-dialog-description"
      disableEnforceFocus
    >
      <DialogTitle id="promotion-dialog-title" align="center">
        Акция
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        {isEditMode && isLoading ? (
          <DialogContentText component="div" sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </DialogContentText>
        ) : (
          <DialogContentText
            id="promotion-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            component="div"
          >
            <PromotionForm promotion={promotion} tariffs={tariffs} onUpdate={onUpdate} />
          </DialogContentText>
        )}
      </DialogContent>
    </Dialog>
  );
}
